import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=2af0e825&scoped=true&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=2af0e825&scoped=true&lang=css&"
import style2 from "./crudServices.vue?vue&type=style&index=2&lang=css&"
import style3 from "./crudServices.vue?vue&type=style&index=3&id=2af0e825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0e825",
  null
  
)

export default component.exports